import React from "react";
import PropTypes from "prop-types";

import Button from "../Components/Button";

export default class ExternalLink extends React.Component {
    render(){
        let is_in_stock = this.props.is_in_stock;
        let isClickToBuy = false;

        if(typeof is_in_stock === "string"){
            if(is_in_stock === ""){
                is_in_stock = true;
            } else {
                is_in_stock = false;
            }
        }

        if(this.props.external_link_text.toLowerCase() === "click to buy"){
            isClickToBuy = true;
        }

        return(
            <div>
                {is_in_stock ? (
                    <Button
                        id="product_button_external"
                        label={this.props.external_link_text}
                        href={this.props.external_link}
                        icon="far fa-shopping-cart"
                        className="btn highlight"
                        target={isClickToBuy ? "_blank" : "_self"}
                    />
                ) : (
                    <Button
                        label="Item is out of stock"
                        className="btn highlight"
                        disabled={true}
                    />
                )}

            </div>
        );
    }
}

ExternalLink.propTypes = {
    external_link: PropTypes.string.isRequired,
    external_link_text: PropTypes.string.isRequired,
    is_in_stock: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool
    ]),
};
